import * as sx from "./square.sx";

export const { square } = sx;

export const SQUARE_ASPECT_RATIO: React.CSSProperties = { aspectRatio: "1" };

export function Square({
  className,
  ref,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) {
  return (
    /* the first div limits width, but tall viewports can still have excess height */
    <sx.Square className={className}>
      {/* the second div limits height; I don't understand why, but it works */}
      <sx.Square {...props} ref={ref} />
    </sx.Square>
  );
}
